import * as React from 'react';
import { observer } from "mobx-react";

import { DropdownView } from 'src/core/ui/dropdown.view';

interface UserEditorViewProps {
	mode: ControlMode;
	label?: string;
	userRequest: DropdownRequest<UserSummary>;
	value: number | null;
	onChanged: (number: UserSummary | null) => void;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	readOnly?: boolean;
}

@observer
export class UserEditorView extends React.Component<UserEditorViewProps, any> {
	public constructor(props) {
		super(props);
	}

	public render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'User';
		}

		return (
			<DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				readOnly={this.props.readOnly}
				model={this.props.value}
				disabled={this.props.mode == 'display'}
				required={this.props.required}
				onChanged={this.props.onChanged}
				request={this.props.userRequest}
				keyField='id'
				textField='displayName'
				placeholder="Select a User..."
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/users/parts/user-editor.view.tsx